import teamManagerIcon from "../../assets/icon/team-manager.svg"
import trashIcon from "../../assets/icon/trash.svg"
import ProfilePicture from "../profile-picture/ProfilePicture"
import {useTranslation} from "react-i18next"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import isLicenceValidity from "../../tools/isLicenceValidity"
import {toast} from "react-toastify"

export default function TeamUserCard({user, idAdmin, type}) {
    const {t} = useTranslation()
    const {teamContext, setTeamAction} = useTeamContext()

    const deleteUser = () => {
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            setTeamAction({type: "TEAM_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: true, id: user.id, action: "delete"}}})
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."))
        }
    }

    return (
        <>
        <div className="team-user-card">
            <ProfilePicture idUser={user.id}/>
            <p title={user.email}>{user.email}</p>
            {user.id === idAdmin && <img className="team-manager-icon" src={teamManagerIcon} alt="" title={user.id === idAdmin && t("Team manager")}/>}
            {type === "team-management" ? <><img className="trash-btn" src={trashIcon} alt="" onClick={deleteUser} title={t("Delete user")}/></> : ""}
        </div>
        </>
    )
}